import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Helmet from 'react-helmet'

import data from './data.json'
import Home from './views/Home'
import ScrollToTop from './components/ScrollToTop'
import GoogleAnalytics from './components/GoogleAnalytics'
import Contact from './views/Contact'
import Default from './views/Default'
import NoMatch from './views/NoMatch'
import Nav from './components/Nav'
import Footer from './components/Footer'
import globalStyles from './globalStyles'

const menuItems = [
  {
    title: 'Flora survey',
    path: '/flora-survey/'
  },
  {
    title: 'Consulting',
    path: '/consulting/'
  },
  {
    title: 'Community Support',
    path: '/community-support/'
  },
  {
    title: 'Sample Projects',
    path: '/sample-projects/'
  },
  {
    title: 'About',
    path: '/about/'
  },
  {
    title: 'Contact',
    path: '/contact-us/'
  }
]

class App extends Component {
  state = {
    data
  }

  componentWillMount () {
    globalStyles()
  }

  getDocument = (collection, name) =>
    this.state.data[collection] &&
    this.state.data[collection].filter(page => page.name === name)[0]

  getDocuments = collection => this.state.data[collection]

  render () {
    const globalSettings = this.getDocument('settings', 'global')
    const { siteTitle, siteDesc } = globalSettings

    const pages = this.getDocuments('pages')

    const routes = pages.map(page => {
      if (page.id === 89) {
        return {
          data: page,
          title: page.title,
          path: '/',
          comp: Home,
          exact: true
        }
      }
      if (page.slug === 'contact-us') {
        return {
          data: page,
          title: page.title,
          path: `/${page.slug}/`,
          comp: Contact,
          exact: true
        }
      }
      return {
        data: page,
        title: page.title,
        path: `/${page.slug}/`,
        comp: Default,
        exact: true
      }
    })

    return (
      <Router>
        <div>
          <ScrollToTop />
          <GoogleAnalytics />
          <Helmet
            titleTemplate={`${siteTitle} - %s`}
            defaultTitle={`${siteTitle} - ${siteDesc}`}
          />
          <Nav menuItems={menuItems} />
          <Switch>
            {routes.map((route, i) => (
              <Route
                {...route}
                key={i}
                render={({ location }) => {
                  return <route.comp {...route} />
                }}
              />
            ))}
            <Route component={NoMatch} />
          </Switch>
          <Footer menuItems={menuItems} />
        </div>
      </Router>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js